// extracted by mini-css-extract-plugin
module.exports = {"default":"_type_default__w1w99","right":"_type_right__3Joop","left":"_type_left__3QLwH","top":"_type_top__1xx9r","bottom":"_type_bottom__Uj3ez"};